import { format, parse } from "date-fns";

import type { PlanITDocumentationInfoType } from "components/PlanIT/queryKeys";

export const shouldRenderSection = (fields: (keyof PlanITDocumentationInfoType)[], data: PlanITDocumentationInfoType) => fields.some(field => field in data);
export const formatTime = (time: number | undefined) => {
  if (!time) return "";
  const stringTime = String(time).padStart(4, "0");
  const parsedTime = parse(stringTime, "HHmm", new Date());
  return format(parsedTime, "HH:mm");
};
